import _ from 'lodash'
import Vue from 'vue'
import apiCall from './call'

const search = {

  state: {
    searching: false,
    searchTerm: null
  },

  mutations: {
    clearSearch (state, searchTypes) {
      state.searching = false
      state.searchTerm = null

      _.each(searchTypes, function (searchType, key) {
        Vue.set(state, 'result' + key, {
          name: searchType.name,
          pending: false,
          results: []
        })
      })
    },

    startSearch (state, payload) {
      state.searching = true
      state.searchTerm = payload.searchTerm

      _.each(payload.searchTypes, function (searchType, key) {
        Vue.set(state, 'result' + key, {
          name: searchType.name,
          pending: true,
          results: []
        })
      })
    },

    updateResult (state, results) {
      Vue.set(state, 'result' + results.key, {
        name: results.name,
        pending: false,
        results: results.results
      })
    }
  },

  actions: {
    doGlobalSearch ({ commit, state, getters }, searchTerm) {
      if (searchTerm === '' || _.isNull(searchTerm)) {
        commit('clearSearch', getters.searchTypes)
        return
      }

      commit('startSearch', {
        searchTerm,
        searchTypes: getters.searchTypes
      })

      _.each(getters.searchTypes, function (searchType, key) {
        apiCall({
          url: searchType.url,
          method: 'GET',
          qs: {
            search: searchTerm,
            paginate: 5
          }
        }).then(response => {
          commit('updateResult', {
            key: key,
            name: searchType.name,
            results: response.data
          })
        }).catch(error => {
          if (error.response.status === 404) {
            commit('updateResult', {
              key: key,
              name: searchType.name,
              results: []
            })
          }
        })
      })
    },

    clearGlobalSearch ({ commit, state }) {
      commit('clearSearch')
    }
  },

  getters: {
    globalSearchResults: (state, getters) => {
      let searchResults = []

      _.each(getters.searchTypes, function (searchType, key) {
        if (!_.has(state, 'result' + key)) {
          searchResults.push({
            name: searchType.name,
            pending: false,
            results: []
          })
        } else {
          searchResults.push(state['result' + key])
        }
      })

      return searchResults
    },

    isGlobalSearchActive: state => {
      return state.searching
    },

    globalSearchTerm: state => {
      return state.searchTerm
    },

    searchTypes: (state, getters, rootState, rootGetters) => {
      let searchTypes = []

      if (rootGetters.userCan('view_company_accounts', 'accounts')) {
        searchTypes.push({ name: 'Accounts', url: 'accounts/search' })
      }

      if (rootGetters.userCan('view_account_properties', 'account_properties')) {
        searchTypes.push({ name: 'Account Properties', url: 'account_properties/search' })
      }

      if (rootGetters.userCan('view_all_system_companies', 'companies')) {
        searchTypes.push({ name: 'Companies', url: 'companies/search' })
      }

      if (rootGetters.userCan('view_company_users', 'users') || rootGetters.userCan('view_all_system_users', 'user')) {
        searchTypes.push({ name: 'Users', url: 'users/search' })
      }

      if (rootGetters.userCan('view_subscriptions', 'subscriptions')) {
        searchTypes.push({ name: 'Subscriptions', url: 'subscriptions/search' })
      }

      if (rootGetters.userCan('view_all_roles', 'role')) {
        searchTypes.push({ name: 'Roles', url: 'roles/search' })
      }

      return searchTypes
    }
  }

}

export default search



// WEBPACK FOOTER //
// ./src/store/modules/search.js